import { FC, Fragment } from "react";
import React from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { NumberInput } from "../core/NumberField";
import { useStyles } from "../../useStyles";
import { Switch } from "../core/Switch";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";
import { ElevatorIcon } from "../core/icons/Icons";
import { InputLabel } from "@material-ui/core";

export const AdjustableLoadElectricElevatorForm: FC = () => {
    const classes = useStyles();
    const { values, getFieldProps, setValues } = useFormModel<
        ChangeNames.ADJUSTABLE_LOAD_ELECTRICAL_ELEVATOR
    >();
    return (
        <Fragment>
            <BoxedInputWithIconAndOptionalSwitch
                icon={<ElevatorIcon />}
                content={
                    <p className={classes.label} style={{ marginBottom: 24 }}>
                        Aufzugsanlage
                    </p>
                }
                useSwitch={
                    <Switch
                        checked={values.adjustableLoadElectricElevator.value.installed}
                        {...getFieldProps("adjustableLoadElectricElevator.value.installed")}
                        onChange={(e, checked) =>
                            setValues(values => {
                                values.adjustableLoadElectricElevator.value.installed = checked;
                                values.adjustableLoadElectricElevator.value.demand.amount = checked
                                    ? 0
                                    : null;
                            })
                        }
                    />
                }
                detailCondition={values.adjustableLoadElectricElevator.value.installed}
                detail={
                    <Fragment>
                        <InputLabel
                            className={classes.labledTextfieldLabel}
                            style={{ marginTop: 0 }}
                        >
                            Summe der Leistung
                        </InputLabel>
                        <NumberInput
                            className={classes.textField}
                            fixedDecimalScale={false}
                            allowLeadingZeros={false}
                            decimalScale={values.adjustableLoadElectricElevator.value.demand.precision}
                            isNumericString={false}
                            allowNegative={false}
                            thousandSeparator="."
                            decimalSeparator=","
                            adornment={values.adjustableLoadElectricElevator.value.demand.unit}
                            value={values.adjustableLoadElectricElevator.value.demand.amount || ""}
                            placeholder="0"
                            onValueChange={v =>
                                setValues(values => {
                                    values.adjustableLoadElectricElevator.value.demand.amount =
                                        v.floatValue || null;
                                })
                            }
                            error={values.adjustableLoadElectricElevator.error != null}
                        />
                    </Fragment>
                }
            />
        </Fragment>
    );
};
